import { useState } from "react";
import { hasLocalImage } from "../lib/data";

export const LocalImage = ({ src, alt, loading = "lazy", onError, ...props }) => {
  const [failed, setFailed] = useState(null);
  if (!hasLocalImage(src) || failed === src) return null;

  return (
    <img src={src} alt={alt} loading={loading} decoding="async" {...props}
      onError={() => { setFailed(src); onError?.(); }} />
  );
};
